import { Marker, OverlayView, OverlayViewF } from '@react-google-maps/api'
import React from 'react'
import { useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { OneFreeStationIcon } from 'assets/images/Markers/Parkings'
import { Shared } from 'ui/shared'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import { To } from 'router/To'
import { useDispatch } from 'react-redux'
import { Actions_Bookings } from 'redux/modules/bookings/Actions'
import { makeStyles } from 'tss-react/mui'

export const Markers = () => {
  const dispatch = useDispatch()
  const pickUpParkings = useSelector((state: TState) => state.bookings.pickUpParkings)
  const selectedPickUpParking = useSelector((state: TState) => state.bookings.selectedPickUpParking)

  const { classes } = useStyles()

  return (
    <>
      {pickUpParkings.map((item) => {
        return (
          <Marker
            key={item.parkingInfo.id}
            position={{
              lat: item.parkingInfo.latitude,
              lng: item.parkingInfo.longitude,
            }}
            onClick={() => dispatch(Actions_Bookings.store.setSelectedPickUpParking(item))}
            icon={{
              url: OneFreeStationIcon,
              scaledSize: true
                ? {
                    width: 63,
                    height: 83.25,
                    equals(other) {
                      return false
                    },
                  }
                : null,
            }}
          ></Marker>
        )
      })}
      {selectedPickUpParking && (
        <>
          <OverlayViewF
            position={{
              lat: selectedPickUpParking.parkingInfo.latitude,
              lng: selectedPickUpParking.parkingInfo.longitude,
            }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <Shared.InfoWindow
              Content={() => (
                <>
                  <Typography title={selectedPickUpParking.parkingInfo.parkingCode} variant="subtitle1" noWrap>
                    {selectedPickUpParking.parkingInfo.parkingCode}
                  </Typography>
                  <Typography variant="body1" noWrap>
                    {selectedPickUpParking.trailers?.length} free trailer
                  </Typography>
                  <div></div>
                  <div></div>
                </>
              )}
              Footer={() => (
                <>
                  <Link to={`${To.parkingDetails}/${selectedPickUpParking.parkingInfo.id}`} className={classes.link}>
                    <Typography
                      variant="body1"
                      noWrap
                      style={{
                        color: 'red',
                        cursor: 'pointer',
                      }}
                    >
                      Details
                    </Typography>
                  </Link>
                </>
              )}
            />
          </OverlayViewF>
        </>
      )}
    </>
  )
}

const useStyles = makeStyles()({
  link: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      color: 'red',
    },
  },
})
